import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from 'src/app/shared/_service/api.service';
import { Subject, forkJoin } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/_service/auth.service';

@Component({
	selector: 'app-configurazione-utenti',
	templateUrl: './configurazione-utenti.component.html',
})
export class ConfigurazioneUtentiComponent implements OnInit, OnDestroy {
	constructor(
		private api: ApiService,
		private router: Router,
		private auth: AuthService,
	) {}

	utenti = [];
	user: any;

	dtTrigger: Subject<any> = new Subject<any>();

	ngOnInit() {
		this.user = this.auth.getUser();
		this.api.getUtenti().subscribe((res) => {
			this.utenti = res.map((user) => {
				user.mercati = user.mercati.map((market) => market.codiceMercato).join(', ');
				return user;
			});
			this.dtTrigger.next();
		});
	}

	ngOnDestroy(): void {
		this.dtTrigger.unsubscribe();
	}
}
